import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';

import messages from './paymentForm.messages';
import { Form, Title, NameFields, Input, JudoForm, Errors, ButtonWrapper, Info, LogOut } from './paymentForm.styles';
import judoPayment from '../../services/judoPayment';
import iframeConfig from '../../../routes/booking/payment/iframeConfig';
import { PaymentButton } from '../../../routes/booking/paymentButton';
import { JUDO_ORIGIN } from '../../services/judo';
import { renderWhenTrue } from '../../utils/rendering';
import { PaymentStatus, PaymentStatuses } from '../../../modules/booking/booking.constants';
import Disclaimer from '../../../routes/booking/payment/disclaimer/disclaimer.container';
import { PAYMENT_FIELDS as FIELDS } from '../../../modules/auth/auth.constants';
import { ignoreSpace } from '../../utils/input';

const JUDO_IFRAME_ID = 'payment-iframe';

export class PaymentForm extends PureComponent {
  static propTypes = {
    paymentStatus: PropTypes.oneOf(PaymentStatuses),
    paymentTokenReceived: PropTypes.func,
    handleSubmit: PropTypes.func,
    isSignedIn: PropTypes.bool.isRequired,
    signOut: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
  };

  componentDidMount() {
    judoPayment.initPayment(JUDO_IFRAME_ID, iframeConfig);
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    judoPayment.reset();
    window.removeEventListener('message', this.handleMessage);
  }

  phantomInputRef = React.createRef();

  handleLogout = () => this.props.signOut();

  handleSubmit = e => {
    e.preventDefault();
    this.props.handleSubmit(e);
  };

  handleMessage = e => {
    if (e.origin === JUDO_ORIGIN && e.data.action === 'return') {
      this.props.paymentTokenReceived(e.data.params.oneUseToken);
    }
  };

  renderGenericError = renderWhenTrue(() => (
    <Errors>
      <FormattedMessage {...messages.genericError} />
    </Errors>
  ));

  renderNameField = ({ field, form }) => (
    <Input
      {...field}
      error={form.errors[field.name]}
      touched={form.touched[field.name]}
      type="text"
      light
      label={this.props.intl.formatMessage(messages[field.name])}
      disabled={this.props.isSignedIn}
    />
  );

  renderEmailField = ({ field, form }) => (
    <Input
      {...field}
      error={form.errors[field.name]}
      touched={form.touched[field.name]}
      type="email"
      light
      onKeyDown={ignoreSpace}
      label={this.props.intl.formatMessage(messages[field.name])}
      disabled={this.props.isSignedIn}
    />
  );

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <Title>
          <FormattedMessage {...messages.title} />
        </Title>
        <NameFields>
          <Field name={FIELDS.firstName} render={this.renderNameField} />
          <Field name={FIELDS.lastName} render={this.renderNameField} />
        </NameFields>
        <Field name={FIELDS.email} render={this.renderEmailField} />
        {renderWhenTrue(() => (
          <Info>
            <FormattedMessage
              {...messages.notYou}
              values={{
                logOut: (
                  <LogOut onClick={this.handleLogout}>
                    <FormattedMessage {...messages.logOut} />
                  </LogOut>
                ),
              }}
            />
          </Info>
        ))(this.props.isSignedIn)}
        <Title>
          <FormattedMessage {...messages.secure} />
        </Title>
        <JudoForm id={JUDO_IFRAME_ID} />
        <Errors className="judopay-errors" />
        {this.renderGenericError(this.props.paymentStatus === PaymentStatus.FAILED)}
        <Disclaimer />
        <ButtonWrapper>
          <PaymentButton />
        </ButtonWrapper>
      </Form>
    );
  }
}
